"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_PARTAGE = exports.FR_PARTAGE = void 0;
/**
 * Espace « partage » du catalogue ICU — F-LNG-01, F-LNG-04 (PP-05).
 *
 * Un fichier par espace de noms, pour qu'une surface n'embarque que les siens :
 * le catalogue complet pèse ~380 Ko et chaque application n'en lit qu'une part.
 * Les deux langues vivent côte à côte pour que l'anglais reste livré avec le français.
 */
exports.FR_PARTAGE = {
    // ── Page publique de partage de trajet — F-CNF-07, F-CNF-08 (SA-16) ────────
    'partage.chargement': 'Ouverture du suivi…',
    'partage.position_absente.titre': 'La position n’est pas encore disponible',
    'partage.position_absente.sous_titre': 'Elle s’affichera ici dès qu’elle sera connue. Cette page se met à jour toute seule.',
    'partage.en_route.titre': 'Le véhicule est en route',
    'partage.arrivee_estimee': 'Arrivée à destination vers {heure}',
    'partage.arrivee_estimee_indisponible': 'Heure d’arrivée non disponible pour le moment',
    'partage.carte.etiquette': 'Position du véhicule sur la carte',
    'partage.carte_indisponible': 'Carte non disponible pour le moment',
    'partage.mention_pas_d_installation': 'Aucune application à installer.',
    'partage.expire.titre': 'Ce lien n’est plus actif',
    'partage.expire.description': 'Le trajet est terminé ou le lien a été fermé. La position en direct n’est plus consultable. Rien n’est conservé sur cette page.',
    'partage.introuvable.titre': 'Lien introuvable',
    'partage.introuvable.description': 'Vérifiez l’adresse reçue : ce lien de partage n’existe pas.',
    'partage.erreur.titre': 'Impossible d’afficher ce suivi',
    'partage.erreur.description': 'La connexion a échoué. Vérifiez le réseau puis réessayez.',
    'partage.pied.suivi_par': 'Suivi partagé',
};
exports.EN_PARTAGE = {
    // ── Public trip-sharing page — F-CNF-07, F-CNF-08 (SA-16) ───────────────────
    'partage.chargement': 'Opening the trip…',
    'partage.position_absente.titre': 'The position is not available yet',
    'partage.position_absente.sous_titre': 'It will show here as soon as it is known. This page updates by itself.',
    'partage.en_route.titre': 'The vehicle is on its way',
    'partage.arrivee_estimee': 'Arriving at the destination around {heure}',
    'partage.arrivee_estimee_indisponible': 'Arrival time not available right now',
    'partage.carte.etiquette': 'Vehicle position on the map',
    'partage.carte_indisponible': 'Map not available right now',
    'partage.mention_pas_d_installation': 'No app to install.',
    'partage.expire.titre': 'This link is no longer active',
    'partage.expire.description': 'The trip has ended or the link was closed. The live position is no longer available. Nothing is kept on this page.',
    'partage.introuvable.titre': 'Link not found',
    'partage.introuvable.description': 'Check the address you received: this sharing link does not exist.',
    'partage.erreur.titre': 'Unable to show this trip',
    'partage.erreur.description': 'The connection failed. Check your network and try again.',
    'partage.pied.suivi_par': 'Shared trip',
};
//# sourceMappingURL=partage.js.map